// Cost of the product batches an operation uses. Same rule as the server cost ledger
// (costLedgerService.recordTreatmentCostLedger): the batch quantity is in kg (or L), while the unitary cost is
// per unit of the product's dose (drugsService stores it so): per mg for mg/L, per g for g/hL, g/L and
// g/100 Kg, as it is for L and Kg. Units: reference data in the server migrations (public.units).
const QUANTITY_FACTOR = { 1: 1_000_000, 2: 1000, 6: 1000, 7: 1000 };

export const drugBatchCost = (unitId, batch) =>
  Number(batch?.quantity) * (QUANTITY_FACTOR[Number(unitId)] || 1) * Number(batch?.unitary_cost) || 0;

// Cost of one product row (treatments table, its footer, the products cost KPI): its batches.
export const drugRowCost = (row) =>
  (row?.drug_batches || []).reduce((acc, batch) => acc + drugBatchCost(row?.unit_id, batch), 0);
